import axios from "axios";
import { handleJWT, rmStorageAndReload } from "./handleJWT";

const SERVER_URL = `${process.env.REACT_APP_SITEURL}/users`;

const getUserInfoApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/users/getInfo`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getUserInfoApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};
const setUserInfoApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/users/setInfo`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await setUserInfoApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

export { getUserInfoApi, setUserInfoApi };
